var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"p-3 border rounded mt-2 ",staticStyle:{"background":"#eee"}},[(_vm.editor)?_c('div',{staticClass:"mb-2"},[_c('button',{staticClass:"btn btn-sm btn-dark mr-1",class:{ 'is-active': _vm.editor.isActive('heading', { level: 2 }) },on:{"click":function($event){_vm.editor
          .chain()
          .focus()
          .toggleHeading({ level: 2 })
          .run()}}},[_vm._v(" h2 ")]),_c('button',{staticClass:"btn btn-sm btn-dark mr-1",class:{ 'is-active': _vm.editor.isActive('heading', { level: 3 }) },on:{"click":function($event){_vm.editor
          .chain()
          .focus()
          .toggleHeading({ level: 3 })
          .run()}}},[_vm._v(" h3 ")]),_c('span',{staticClass:"mr-1"},[_vm._v("|")]),_c('button',{staticClass:"btn btn-sm btn-dark mr-1",class:{ 'is-active': _vm.editor.isActive('bold') },on:{"click":function($event){_vm.editor
          .chain()
          .focus()
          .toggleBold()
          .run()}}},[_c('font-awesome-icon',{attrs:{"icon":"bold"}})],1),_c('button',{staticClass:"btn btn-sm btn-dark mr-1",class:{ 'is-active': _vm.editor.isActive('italic') },on:{"click":function($event){_vm.editor
          .chain()
          .focus()
          .toggleItalic()
          .run()}}},[_c('font-awesome-icon',{attrs:{"icon":"italic"}})],1),_c('button',{staticClass:"btn btn-sm btn-dark mr-1",class:{ 'is-active': _vm.editor.isActive('strike') },on:{"click":function($event){_vm.editor
          .chain()
          .focus()
          .toggleStrike()
          .run()}}},[_c('font-awesome-icon',{attrs:{"icon":"strikethrough"}})],1),_c('span',{staticClass:"mr-1"},[_vm._v("|")]),_c('button',{staticClass:"btn btn-sm btn-dark mr-1",class:{ 'is-active': _vm.editor.isActive('bulletList') },on:{"click":function($event){_vm.editor
          .chain()
          .focus()
          .toggleBulletList()
          .run()}}},[_c('font-awesome-icon',{attrs:{"icon":"list-ul"}})],1)]):_vm._e(),_c('editor-content',{staticClass:"p-2 border bg-white",attrs:{"editor":_vm.editor}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }